import { fetchQuery } from "relay-runtime";
import environment from "environments/environment";
import getEventQuery from "./queries/getEvent";
import getEventsQuery from "./queries/getEvents";
import testInviteMutation from "./mutations/testInvite"
import testEmailMutation from "./mutations/testEmail"
import scheduleEvent from "./mutations/scheduleEvent"
import getContacts from "./queries/getContacts"
import getAttendeesQuery from "./queries/getAttendees";
import getEventTemplateFieldsQuery from "./queries/getEmailTemplatefields";
import getAssetCategoryIdQuery from "./queries/getAssetCategoryId";
import getEventlessFieldsQuery from "./queries/getEventlessFields";
import getInviteEmailQuery from "./queries/getInviteEmail";
import getOrgQuery from "./queries/getOrg";
import getAttendeesOverviewQuery from "./queries/getAttendeesOverview"
import getAttendeesInviteesStatusQuery from "./queries/getAttendeesInviteesStatus";
import getAttendeesPropertiesBreakdownQuery from "./queries/getAttendeesPropertiesBreakdown"
import getOrgEventsQuery from "./queries/getOrgEvents"
import getLeadsFieldQuery from "./queries/getLeadFields"
import getSuborgDetailsQuery from "./queries/getSuborgDetails"
import getEventsV2Query from "./queries/getEventsV2";
import importLogsQuery from "./queries/importLogs"

const getDefaultOrg = (appName) => {
  let variables = { appName, first: 1 };
  return fetchQuery(environment, getOrgQuery, variables)
}


const getEventlessFields = (id) => {
  let variables = { id };
  return fetchQuery(environment, getEventlessFieldsQuery, variables)
}

const getAssetCategoryId = (propertyId, type) => {
  let variables = { propertyId, type };
  return fetchQuery(environment, getAssetCategoryIdQuery, variables).then(res => {
    if (res.categories) return res.categories[0].id;
    return ""
  })
    .catch(err => {
      return { errors: [{ message: err.toString() }] };
    });
}

const getEventTemplateFields = (id) => {
  let variables = { id };
  return fetchQuery(environment, getEventTemplateFieldsQuery, variables)
}

const getEvent = (id) => {
  let variables = { id };
  return fetchQuery(environment, getEventQuery, variables)
}

const getInviteEmail = (id) => {
  let variables = { id };
  return fetchQuery(environment, getInviteEmailQuery, variables)
}

const getEvents = (propertyId, startAt, endAt, status, search, last, before, type) => {
  const variables = { propertyId, startAt, endAt, status, search, last, before, type };
  return fetchQuery(environment, getEventsQuery, variables)
    .then(res => {
      return res;
    })
    .catch(err => {
      return { errors: [{ message: err.toString() }] };
    });
}

const getContactGroups = (propertyId) => {
  const variables = { propertyId };
  return fetchQuery(environment, getContacts, variables)
    .then(res => {
      return res;
    })
    .catch(err => {
      return { errors: [{ message: err.toString() }] };
    });
}

const getAttendees = (eventId) => {
  const variables = { eventId };
  return fetchQuery(environment, getAttendeesQuery, variables);
}

const getAttendeesOverview = (orgId, propertyId, startAt, endAt) => {
  const variables = { orgId, propertyId, startAt, endAt }
  return fetchQuery(environment, getAttendeesOverviewQuery, variables)
}

const getAttendeesInviteesStatus = (orgId, eventIds) => {
  const variables = { orgId, eventIds }
  return fetchQuery(environment, getAttendeesInviteesStatusQuery, variables)
}

const getAttendeesPropertiesBreakdown = (input) => {
  const variables = { ...input }
  return fetchQuery(environment, getAttendeesPropertiesBreakdownQuery, variables)
}


const getOrgEvents = (orgId, startAt, endAt, status, search, after, before, first, last) => {
  const variables = { orgId, startAt, endAt, status, search, after, before, first, last }
  return fetchQuery(environment, getOrgEventsQuery, variables)
}

const getLeadFields = (propertyId) => {
  const variables = { propertyId }
  return fetchQuery(environment, getLeadsFieldQuery, variables)
}

const getSuborgDetails = (id) => {
  let variables = { id };
  return fetchQuery(environment, getSuborgDetailsQuery, variables)
}

const getEventsV2 = (propertyId, startAt, endAt, type) => {
  const variables = { propertyId, startAt, endAt, type };
  return fetchQuery(environment, getEventsV2Query, variables)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return { errors: [{ message: err.toString() }] };
    });
};

const importLogs = (propertyId) => {
  let variables = { propertyId };
  return fetchQuery(environment, importLogsQuery, variables);
};

const testInvite = testInviteMutation;
const testEmail = testEmailMutation;

export {
  getEvent,
  getEvents,
  testInvite,
  scheduleEvent,
  getContactGroups,
  getAttendees,
  getEventTemplateFields,
  getAssetCategoryId,
  getEventlessFields,
  getInviteEmail,
  getDefaultOrg,
  getAttendeesOverview,
  getAttendeesInviteesStatus,
  getAttendeesPropertiesBreakdown,
  getOrgEvents,
  getLeadFields,
  getSuborgDetails,
  testEmail,
  getEventsV2,
  importLogs
};